import {css} from 'lit';
export const styles = css`:host {
  --image-size: 50px;
  --remove-button-size: 24px;
  --remove-button-color: var(--dark-text-secondary);
  --remove-button-bg: var(--contrast-light);
  --remove-button-fs: var(--font-size-base);
  --big-button-margin: 4px 8px;
  --big-button-padding: 8px;
  --big-button-bg: var(--contrast-light);
  --big-button-fs: var(--font-size-sm);
  --big-button-border: 1px solid var(--input-border);
  --big-button-icon-size: var(--font-size-base);
  --upload-button-color: var(--dark-text);
  --clear-button-color: var(--danger);
  --attached-file-shadow: 0 0 8px var(--primary);
  --file-border: none;
  --ef-attachment-border-radius: 6px;

  display: block;
}

ef-grid-list + ef-grid-list {
  margin-top: 16px;
}

.attached,
.uploaded {
  position: relative;
}

.attached img,
  .attached ef-attachment,
  .uploaded img,
  .uploaded ef-attachment {
    margin-top: calc(var(--remove-button-size) / 2);
    border: var(--file-border);
  }

.attached img, .uploaded img {
    width: var(--image-size);
    height: var(--image-size);
    object-fit: cover;
  }

.attached ef-attachment, .uploaded ef-attachment {
    border-radius: var(--ef-attachment-border-radius);
  }

.attached img,
  .attached ef-attachment {
    box-shadow: var(--attached-file-shadow);
  }

.btn-remove {
  position: absolute;
  top: 0;
  right: calc(var(--remove-button-size) / -2);
  width: var(--remove-button-size);
  height: var(--remove-button-size);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--remove-button-color);
  background-color: var(--remove-button-bg);
  color: var(--remove-button-color);
  border-radius: 50%;
  font-size: var(--remove-button-fs);
  z-index: 1;
}

@media (hover: hover) {

.btn-remove {
    cursor: pointer
}

    .btn-remove:hover {
      border-color: var(--danger);
      color: var(--danger);
    }
  }

.btn-remove:active {
    color: var(--remove-button-color);
    border-color: var(--remove-button-color);
  }

.btn-remove.all {
    position: static;
    position: initial;
  }

.btn-remove[hidden] {
    display: none;
  }

.btn-upload,
.btn-clear {
  margin: var(--big-button-margin);
  padding: var(--big-button-padding);
  background-color: var(--big-button-bg);
  font-size: var(--big-button-fs);
  color: var(--upload-button-color);
  border: var(--big-button-border);
  border-radius: 4px;
}

@media (hover: hover) {

.btn-upload,
.btn-clear {
    cursor: pointer
}

    .btn-upload:hover, .btn-clear:hover {
      opacity: 0.8;
    }
  }

.btn-upload:active, .btn-clear:active {
    opacity: 0.9;
  }

.btn-upload ef-icon, .btn-clear ef-icon {
    font-size: var(--big-button-icon-size);
  }

.btn-clear {
  color: var(--clear-button-color);
}

:host([disabled]) .btn-remove,
  :host([disabled]) .btn-clear {
    display: none;
  }

:host([disabled]) .btn-upload {
    pointer-events: none;
  }
`;
export default styles;
